import { useQuery } from '@tanstack/react-query';
import { ENTITY_TYPE_LABELS, type EntityType } from '@raro/domain';
import { Input } from '@raro/ui';
import { useState } from 'react';
import { api } from '../lib/api';
import type { EntitySummary } from '../lib/types';

/** Lista tudo do projeto para escolher um objeto: relacionar, colocar na parede. */
export function EntityPicker({
  projectId,
  types,
  exclude,
  selected,
  onSelect,
}: {
  projectId: string;
  types?: EntityType[];
  exclude?: { type: EntityType; id: string }[];
  selected?: { type: EntityType; id: string } | null;
  onSelect: (e: EntitySummary) => void;
}) {
  const [q, setQ] = useState('');
  const entities = useQuery({ queryKey: ['entities', projectId], queryFn: () => api.get<EntitySummary[]>(`/projects/${projectId}/entities`) });
  const items = (entities.data ?? [])
    .filter((e) => !types || types.includes(e.type))
    .filter((e) => !exclude?.some((x) => x.type === e.type && x.id === e.id))
    .filter((e) => !q || e.title.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="rr-stack rr-stack--2">
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="filtrar…" />
      <div className="rr-picker">
        {items.length === 0 && <div className="rr-picker__item rr-faint">nada por aqui.</div>}
        {items.map((e) => (
          <button key={`${e.type}-${e.id}`} type="button" className="rr-picker__item" aria-selected={selected?.type === e.type && selected.id === e.id} onClick={() => onSelect(e)}>
            <span className="rr-picker__type">{ENTITY_TYPE_LABELS[e.type]}</span>
            <span>{e.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
